"use strict";
var hlp = require('common/helpers');
var controller = function($scope, $rootScope, $http, $timeout) {
  var saveFilter = function(params) {
    localStorage.setItem($scope.filter, JSON.stringify(params));
  };
  var initGetWorks = function() {
    if (hlp.isSet($scope.getWorks)) {
      return;
    }
    $scope.getWorks = function() {
      $scope.loading = true;
      var params = {
        "archivnr": $scope.archivnr,
        "query": $scope.query,
        "page": $scope.page,
        "per_page": $scope.per_page
      };
      if ($scope.id !== undefined) {
        params["collectionId"] = $scope.id;
      }
      $http.get('/api/work.json', {params: params}).success(function(data, status, headers, config) {
        $scope.works = data.works;
        $scope.count = data.count;
        params['displayMode'] = $scope.displayMode;
        saveFilter(params);
      }).catch(function(data, status, headers, config) {}).finally(function() {
        $scope.loading = false;
      });
    };
  }();
  $scope.displayMultiple = function(values) {
    if (typeof values === 'undefined') {
      return '';
    }
    return values.join(', ');
  };
  $scope.thumbnailUrl = popup.thumbnailUrl;
  $scope.popup = function(archivnr, dianr) {
    popup.open(archivnr, dianr);
  };
  $scope.refresh = function() {
    $scope.getWorks();
  };
  $scope.refreshWithPage = function() {
    $scope.page = 1;
    $scope.getWorks();
  };
  $scope.$watch('page', function() {
    $scope.refresh();
  });
  $scope.$watch('per_page', function() {
    $scope.refresh();
  });
  $scope.$watch('doRefresh', function() {
    if ($scope.doRefresh) {
      $scope.refresh();
      $scope.doRefresh = false;
    }
  });
  $scope.setDisplayMode = function(mode) {
    $scope.displayMode = mode;
    $scope.refresh();
  };
  $scope.resetFilter = function() {
    localStorage.removeItem($scope.filter);
    initFilterDefaults();
    $scope.getWorks();
  };
  $scope.setStatus = function(status) {
    if (hlp.isSet(status) && status.type == 'right') {
      if (!hlp.isSet($scope.statusRight) || $scope.statusRight.id != status.id) {
        $scope.statusRight = status;
      } else {
        $scope.statusRight = null;
      }
    } else if (hlp.isSet(status) && status.type == 'editing') {
      if (!hlp.isSet($scope.statusEditing) || $scope.statusEditing.id != status.id) {
        $scope.statusEditing = status;
      } else {
        $scope.statusEditing = null;
      }
    } else {
      $scope.statusRight = null;
      $scope.statusEditing = null;
    }
    if (!hlp.isSet($scope.statusRight) && !hlp.isSet($scope.statusEditing)) {
      $scope.activeStatus = "Alle";
    } else if (hlp.isSet($scope.statusRight) && !hlp.isSet($scope.statusEditing)) {
      $scope.activeStatus = $scope.statusRight.value;
    } else if (!hlp.isSet($scope.statusRight) && hlp.isSet($scope.statusEditing)) {
      $scope.activeStatus = $scope.statusEditing.value;
    } else {
      $scope.activeStatus = $scope.statusEditing.value + ", " + $scope.statusRight.value;
    }
  };
  var initFilterDefaults = function() {
    $scope.per_page = 20;
    $scope.query = "";
    $scope.archivnr = "";
    $scope.page = 1;
    $scope.displayMode = 'table';
    $scope.query = "";
  };
  var initFilter = function() {
    var filter = localStorage.getItem($scope.filter);
    if (hlp.isSet(filter)) {
      var params = JSON.parse(filter);
      $scope.archivnr = params.archivnr;
      $scope.per_page = params.per_page;
      $scope.query = params.query;
      $scope.page = params.page;
      $scope.displayMode = params.displayMode;
    }
  };
  var init = function() {
    if (!hlp.isSet($scope.per_page)) {
      $scope.per_page = 10;
    }
    if (!hlp.isSet($scope.page)) {
      $scope.page = 1;
    }
    if (!hlp.isSet($scope.count)) {
      $scope.count = 0;
    }
    if (!hlp.isSet($scope.displayMode)) {
      $scope.displayMode = 'table';
    }
    initFilter();
    $scope.statusList = [{
      id: "alle",
      value: "Alle"
    }, {
      id: null,
      value: null,
      type: "divider"
    }, {
      id: "oeffentlich",
      value: "Öffentlich",
      type: "right"
    }, {
      id: "nicht_oeffentlich",
      value: "Nicht Öffentlich",
      type: "right"
    }, {
      id: null,
      value: null,
      type: "divider"
    }, {
      id: "bearbeitung",
      value: "in Bearbeitung",
      type: "editing"
    }, {
      id: "bestätigt",
      value: "Bestätigt",
      type: "editing"
    }];
    $scope.setStatus();
    var result = document.URL.match(/page=([0-9]+)/);
    if (result != null && result.length > 0 && hlp.isSet(result[1])) {
      $scope.page = parseInt(result[1]);
    }
  }();
};
module.exports = controller;
